import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { MarketPageSkeleton } from "@/components/market/MarketSkeletons";

export const Route = createFileRoute("/market/cancelar/$token")({
  pendingComponent: MarketPageSkeleton,
  pendingMs: 0,
  component: CancelOrderPage,
  head: () => ({
    meta: [
      { title: "Cancelar pedido — Structura Market" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});

function CancelOrderPage() {
  const { token } = Route.useParams();
  const [state, setState] = useState<"idle" | "loading" | "ok" | "error">("idle");
  const [message, setMessage] = useState("");

  const cancel = async () => {
    setState("loading");
    try {
      const r = await fetch(`/api/market/cancel/${token}`, { method: "POST" });
      const data = (await r.json()) as { error?: string };
      if (!r.ok) throw new Error(data.error ?? "No se pudo cancelar");
      setState("ok");
    } catch (e) {
      setState("error");
      setMessage(e instanceof Error ? e.message : "Error");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full rounded-xl border p-6 text-center space-y-4">
        {state === "ok" ? (
          <>
            <CheckCircle2 className="h-12 w-12 text-green-600 mx-auto" />
            <h1 className="text-xl font-semibold">Pedido cancelado</h1>
            <p className="text-sm text-muted-foreground">Tu pedido fue cancelado correctamente.</p>
          </>
        ) : state === "error" ? (
          <>
            <XCircle className="h-12 w-12 text-destructive mx-auto" />
            <h1 className="text-xl font-semibold">No se pudo cancelar</h1>
            <p className="text-sm text-muted-foreground">{message}</p>
          </>
        ) : (
          <>
            <h1 className="text-xl font-semibold">Cancelar pedido</h1>
            <p className="text-sm text-muted-foreground">
              ¿Confirmás que querés cancelar este pedido? Solo podés cancelarlo si aún no fue entregado.
            </p>
            <Button onClick={() => void cancel()} disabled={state === "loading"} className="w-full">
              {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : "Confirmar cancelación"}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
